import {COMPARISON_WORDING} from './comparison-wording.model';
import {ConditionComparison} from './condition-comparison.model';
import {CONDITION_VALUE_INPUT} from './condition-value-input.model';
import {EQUALITY_CONDITION_OPERATORS} from './equality-condition-operators.model';

/**
 * Ce qu'offre une condition qui ne vise rien, ou qui vise ce que l'éditeur n'exploite pas :
 * l'égalité pour seule réponse, et rien à saisir.
 *
 * C'est une réponse à donner, pas un choix offert — les sélecteurs qui s'en servent sont éteints.
 */
export const NO_COMPARISON: ConditionComparison = {
    operators: EQUALITY_CONDITION_OPERATORS,
    wording: COMPARISON_WORDING.STATE,
    input: CONDITION_VALUE_INPUT.NONE,
};
